//____ REDIRECT HREF ____ //
//____ AUTHOR: LUBOMÍR BLAŽEK ____ //
function nl_fn_redirect_href() {
    $("a").on("click", function (e){
        e.preventDefault();
        var url = $(this).attr("href");
        $("body").addClass("zoomOut");
        setTimeout(function(){window.location = url},100);
    });
}